import { SegmentedControl } from '@hue/design-system';
import type { InventoryView } from '../../app/list-views.js';
import type { ViewSetter } from '../../app/view-state.js';
import { BalancesPanel } from './balances-panel.js';
import { LocationsPanel } from './locations-panel.js';
import { MovementsPanel } from './movements-panel.js';
import type { InventoryCapabilities } from './shared.js';
import { useInventoryUnits } from './inventory-units.js';
import { PageHeader } from '../../app/page-title.js';

const tabs = [
  ['balances', 'Saldo'],
  ['movements', 'Movimentos'],
  ['locations', 'Locais'],
] as const;

export function CompanyInventory({
  capabilities,
  timeZone,
  view,
  onView,
}: {
  capabilities: InventoryCapabilities;
  timeZone: string;
  view: InventoryView;
  onView: ViewSetter<InventoryView>;
}) {
  const { consolidated } = useInventoryUnits();
  return (
    <section aria-labelledby="company-inventory-title">
      <PageHeader
        trail="Operação / Estoque"
        id="company-inventory-title"
        title="Estoque"
        description="O que existe em cada local, o que entrou e saiu, e os locais que sustentam a conta. O cadastro de produtos fica no Catálogo."
      />
      {consolidated ? (
        <p
          role="status"
          className="mb-5 rounded-2xl border border-surface-border bg-surface-card p-4 text-sm text-content-secondary"
        >
          Visão consolidada: saldo e movimentos de todas as suas unidades, só para consulta. Para
          movimentar ou definir reposição, escolha uma unidade no seletor acima. Ao cadastrar um
          local, escolha a unidade no formulário.
        </p>
      ) : null}
      <SegmentedControl
        tabs
        label="Áreas do estoque"
        className="mb-6"
        options={tabs.map(([value, label]) => ({ value, label }))}
        value={view.tab}
        onChange={(tab) => onView({ tab })}
      />
      {view.tab === 'balances' ? (
        <BalancesPanel capabilities={capabilities} view={view} onView={onView} />
      ) : view.tab === 'movements' ? (
        <MovementsPanel
          capabilities={capabilities}
          timeZone={timeZone}
          view={view}
          onView={onView}
        />
      ) : (
        <LocationsPanel capabilities={capabilities} />
      )}
    </section>
  );
}
